import { Fab, Dialog, DialogContent, Typography, AppBar, Toolbar, IconButton, Button } from "@mui/material";
import React, { useState } from "react";
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";
import { usePageImage } from "../../fetch/fetchImage";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import './ZoomablePageFab.css';
import { usePhoneMode } from "../../hooks";

export default function ZoomablePageFab({ partNumber, pageNumber, position, alwaysShowOnMobile }) {
    const { isMobile } = usePhoneMode();
    const [showZoom, setShowZoom] = useState(false);
    const { image } = usePageImage(partNumber, pageNumber);

    const handleOpen = () => {
        setShowZoom(true);
    }

    const handleClose = () => {
        setShowZoom(false);
    }

    return (
        <div className={`zoom-page-fab${alwaysShowOnMobile && isMobile ? ' always-show' : ''}`} onDoubleClick={(e) => e.stopPropagation()} style={{ top: '1em', right: position === 'right' ? '1em' : null, left: position === 'left' ? '1em' : null, float: position }}>
            {!showZoom ?
                (
                    <Fab
                        size='small'
                        color='primary'

                        onClick={handleOpen}
                    >
                        <ZoomInIcon />
                    </Fab>
                ) : null}
            <Dialog
                style={{ zIndex: 9999 }}
                fullScreen
                open={showZoom}
                onClose={handleClose}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Zoom
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <TransformWrapper minScale={0.25}>
                        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                            <>
                                <Controls />
                                <TransformComponent wrapperStyle={{ maxWidth: '100%', maxHeight: '100%', cursor: 'grabbing' }}>
                                    <img src={image} alt={`Page ${pageNumber}`} />
                                </TransformComponent>
                            </>
                        )}
                    </TransformWrapper>
                </DialogContent>
            </Dialog>
        </div>
    )
}

const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
        <div className="tools">
            <Button title='Zoom In' onClick={() => zoomIn()}><AddIcon /></Button>
            <Button title='Zoom Out' onClick={() => zoomOut()}><RemoveIcon /></Button>
            <Button title='Reset' onClick={() => resetTransform()}><RestartAltIcon /></Button>
        </div>
    );
};